module.exports = ""


//////////////////
// WEBPACK FOOTER
// C:/Users/pkwoy/Desktop/progressive-webb-app/src/app/item-view/item-view.component.html
// module id = ../../../../../src/app/item-view/item-view.component.html
// module chunks = main